export enum GridType {
  any='Any',
  references = 'References',
  audit = 'Audit',
  modification = 'Modification',
}
